import React, { useState } from 'react';
import { PricingSection } from './PricingSection';
import { startCheckout } from '../../services/billing';
import { MODE_LABELS, type BillingInterval, type GameMode } from '../../config/plans';

type Props = {
  /** The locked mode the user tried to open, for contextual copy. */
  mode: GameMode;
};

/**
 * Full-page paywall rendered in place of a Pro mode when a free user selects it.
 * Inline (not a modal) so the locked feature reads as "behind Pro" rather than
 * an interruption, and so the nav stays usable to switch back to a free mode.
 */
export const Paywall: React.FC<Props> = ({ mode }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSelect = async (interval: BillingInterval) => {
    setBusy(true);
    setError(null);
    try {
      await startCheckout(interval); // redirects away
    } catch (err) {
      setBusy(false);
      setError(err instanceof Error ? err.message : 'Could not start checkout.');
    }
  };

  return (
    <div className="max-w-2xl mx-auto text-center py-8">
      <div className="text-4xl mb-3">🔒</div>
      <h2 className="text-2xl font-bold text-white mb-1">
        {MODE_LABELS[mode]} is a Pro feature
      </h2>
      <p className="text-gray-400 mb-8">
        Upgrade to unlock {MODE_LABELS[mode]} and the full training suite.
      </p>
      <PricingSection busy={busy} onSelect={handleSelect} />
      {error && <div className="mt-3 text-sm text-red-400">{error}</div>}
    </div>
  );
};
